import countiesGeoJson from './counties_wgs.json';
import citiesGeoJson from './cities_wgs.json';
import majorHighwaysGeoJson from './major_highways_wgs.json'

import schoolsPrivateImage from './map_markers/FireSmart_MapIcons_School.png';
import hospitalsImage from './map_markers/FireSmart_MapIcons_Hospital.png';
import careFacilitiesImage from './map_markers/FireSmart_MapIcons_NursingHome.png';
import aqsImage from './map_markers/FireSmart_MapIcons_AmbientAirMonitor.png';

countiesGeoJson.layerId = 'arkansas_bound';
citiesGeoJson.layerId = 'arkansas_city_limits';
majorHighwaysGeoJson.layerId = 'arkansas_highways';

export const smokePlumeImg = {
	small: {
		name: 'small',
		url: "./smoke_plume_small.png",
		arcAngle: 30,
		rotation: -47, // Angle needed to rotate image by to make arrow point right (0 degrees)
		centerX: .2, // Percentage value representing how far the center position is (farmer's location) from the left edge of the rotated image.
	},
	large: {
		name: 'large',
		url: "./smoke_plume_large.png",
		arcAngle: 30 - 8,
		rotation: -47,
		centerX: .135
	}
}


const aqsSitesIds = [
	'05-001-0011',
	'05-003-0005',
	'05-035-0005',
	'05-051-0003',
	'05-051-0003',
	'05-067-0001',
	'05-101-0002',
	'05-113-0002',
	'05-113-0003',
	'05-119-0007',
	'05-119-1002',
	'05-119-1008',
	'05-139-0006',
	'05-143-0005',
	'05-143-0006',
	'40-135-9021',
	'47-157-0024',
	'47-157-0021',
	'28-033-0002',
	'28-011-0002',
	'47-045-0004',
	'29-213-0003',
	'29-207-0001',
	'40-001-9009',
	'48-203-0002',
	'22-017-0001'
]

const aqsLayers = {}
const iconSize = .8

for (const x of Array(32).keys()) {
	aqsLayers[`aqs${x}`] = {
		id: `aqs${x}`,
		url: `https://gispub.epa.gov/arcgis/rest/services/OAR_OAQPS/AQSmonitor_sites/MapServer/${x}`,
		source: `featureserver-aqs-src${x}`,
		// paint: {
		// 	'circle-color': "purple",
		// },
		label: 'AQS',
		objectIdField: 'AQS_Site_ID',
		addressField: 'Address',
		arcGisOpts: {
			outFields: ['OBJECTID', 'AQS_Site_ID', 'Local_Site_Name', 'Address'],
			where: `AQS_Site_ID IN ('${aqsSitesIds.join("','")}')`
		},
		type: 'symbol',
		markerImage: aqsImage,
		layout: {
			'icon-image': `aqs${x}`,
			'icon-size': iconSize
		}
	}
}

export const smokeSensitiveAreasLayers = {
	arkansas_highways: {
		id: 'arkansas_highways',
		// url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Transportation/FeatureServer/9',
		// url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Transportation/FeatureServer/10',
		geojson: majorHighwaysGeoJson,
		type: 'line',
		source: 'featureserver-src2',
		paint: {
			'line-color': "blue",
		},
		label: 'Highway',
		objectIdField: 'OBJECTID',
		addressField: 'label',
		arcGisOpts: {
			outFields: ['OBJECTID', 'label'],
			where: '1=1',
			spatialRel: 'esriSpatialRelIntersects',
			geometryType: 'esriGeometryPolyline',
			inSR: 26915,
		}
	},
	arkansas_city_limits: {
		id: 'arkansas_city_limits',
		// url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Boundaries/FeatureServer/4',
		geojson: citiesGeoJson,
		type: 'fill',
		source: 'featureserver-src10',
		paint: {
			'fill-color': "rgba(0, 255, 0, .2)",
		},
		label: 'City Limit',
		objectIdField: 'OBJECTID',
		arcGisOpts: {
			outFields: ['OBJECTID', 'city_name'],
			where: '1=1'
		}
	},
	arkansas_schools_private: {
		id: 'arkansas_schools_private',
		url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Structure/FeatureServer/37',
		source: 'featureserver-src3',
		// paint: {
		// 	'circle-color': "red",
		// },
		label: 'Private School',
		objectIdField: 'objectid',
		addressField: 'address',
		arcGisOpts: {
			outFields: ['objectid', 'name', 'address'],
			where: '1=1'
		},
		type: 'symbol',
		markerImage: schoolsPrivateImage,
		layout: {
			'icon-image': 'arkansas_schools_private',
			'icon-size': iconSize
		}
	},
	arkansas_schools_4yrs_college: {
		id: 'arkansas_schools_4yrs_college',
		url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Structure/FeatureServer/12',
		source: 'featureserver-src5',
		// paint: {
		// 	'circle-color': "red",
		// },
		label: '4 Year College',
		objectIdField: 'objectid',
		addressField: 'staddr',
		arcGisOpts: {
			outFields: ['objectid', 'name', 'staddr'],
			where: '1=1'
		},
		type: 'symbol',
		markerImage: schoolsPrivateImage,
		layout: {
			'icon-image': 'arkansas_schools_4yrs_college',
			'icon-size': iconSize
		}
	},
	arkansas_schools_community_college: {
		id: 'arkansas_schools_community_college',
		url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Structure/FeatureServer/13',
		source: 'featureserver-src6',
		// paint: {
		// 	'circle-color': "yellow",
		// },
		label: 'Community College',
		objectIdField: 'objectid',
		addressField: 'staddr',
		arcGisOpts: {
			outFields: ['objectid', 'name', 'staddr'],
			where: '1=1'
		},
		type: 'symbol',
		markerImage: schoolsPrivateImage,
		layout: {
			'icon-image': 'arkansas_schools_community_college',
			'icon-size': iconSize
		}
	},
	arkansas_hospitals: {
		id: 'arkansas_hospitals',
		url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Health/FeatureServer/3',
		source: 'featureserver-src7',
		// paint: {
		// 	'circle-color': "pink",
		// },
		label: 'Hospital',
		objectIdField: 'objectid',
		addressField: 'address',
		arcGisOpts: {
			outFields: ['objectid', 'name', 'address'],
			where: '1=1'
		},
		type: 'symbol',
		markerImage: hospitalsImage,
		layout: {
			'icon-image': 'arkansas_hospitals',
			'icon-size': iconSize
		}
	},
	arkansas_care_facilities: {
		id: 'arkansas_care_facilities',
		url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Health/FeatureServer/5',
		source: 'featureserver-src8',
		// paint: {
		// 	'circle-color': "pink",
		// },
		label: 'Long Term Care Facility',
		objectIdField: 'objectid',
		addressField: 'locadd',
		arcGisOpts: {
			outFields: ['objectid', 'facility_name', 'locadd'],
			where: '1=1'
		},
		type: 'symbol',
		markerImage: careFacilitiesImage,
		layout: {
			'icon-image': 'arkansas_care_facilities',
			'icon-size': iconSize
		}
	},

	// AQS Monitor Sites layers: https://gispub.epa.gov/arcgis/rest/services/OAR_OAQPS/AQSmonitor_sites/MapServer
	...aqsLayers
}

export const layers = {
	arkansas_bound: {
		id: 'arkansas_bound',
		type: 'fill',
		url: 'https://gis.arkansas.gov/arcgis/rest/services/FEATURESERVICES/Boundaries/FeatureServer/48',
		source: 'featureserver-src',
		geojson: countiesGeoJson,
		paint: {
			'fill-color': "rgba(243,12,76, .05)",
			'fill-opacity': 1,
			'fill-outline-color': 'gray'
		},
		objectIdField: 'OBJECTID',
		arcGisOpts: { // for more opts see: https://github.com/rowanwins/mapbox-gl-arcgis-featureserver
			outFields: ['OBJECTID', 'county_nam'],
			where: '1=1'
		}
	},
	prescribed_burns: {
		id: 'prescribed_burns',
		type: 'circle',
		source: 'burns_source',
		paint: {
			'circle-radius': 8,
			'circle-color': '#B42222'
		}
	},

	...smokeSensitiveAreasLayers
};


